export default __webpack_public_path__ + "static/1-36-0-insight-on-multiple-dashboards-1507a53fba65945525f0ef4e5958b3dc.png";